import { toKebabCase } from '../../../website/static/js/services/convert';

export const prepareClientErrorsToMixpanel = (clientErrors) => {
  const preparedClientErrors = {};

  Object.entries(clientErrors).forEach(([key, value]) => {
    let preparedValue = value;

    if (value) {
      if (
        Array.isArray(value) &&
        typeof value[0] === 'object' &&
        value[0] !== null
      ) {
        preparedValue = value.map((item) =>
          prepareClientErrorsToMixpanel(item),
        );
      }

      preparedClientErrors[toKebabCase(key)] = preparedValue;
    }
  });

  return preparedClientErrors;
};
